import { useLocale } from '@app/core/hooks/useLocale';
import { ModalSize } from '@app/shared/components/modal/base-modal-enums';
import BaseModal from '@app/shared/components/modal/BaseModal';
import { FC } from 'react';

interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  handleReset: () => Promise<void>;
}

const ResetEventModal: FC<Props> = ({ visible, setVisible, handleReset }) => {
  const { l } = useLocale();

  return (
    <BaseModal
      size={ModalSize.Small}
      title={l('_ResetEventValues')}
      buttonConfirmLabel={l('_Reset')}
      buttonCancelLabel={l('_Cancel')}
      onCloseButtonClick={() => setVisible(false)}
      onConfirm={handleReset}
      onCancel={() => setVisible(false)}
      isOpen={visible}>
      {l('_ThisWillResetTheEventBackToThePreviousValues')}
    </BaseModal>
  );
};

export default ResetEventModal;
